import ratmService from "./RATMService";

const searchRoleTemplates = (event: { target: { value: string | null } }) => {

    const { manageState, searchRoleTemplatesKeys, roleTemplatesCopy } = ratmService;

    const input = event.target.value?.trim().toLowerCase() || "";

    if (input) {
        let filtered = roleTemplatesCopy.filter(templateObj => {
            let concatenatedKeys = searchRoleTemplatesKeys
                //@ts-ignore
                .map(key => templateObj.Template[key] ? templateObj.Template[key] : "")
                .join(" ")
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();

            return concatenatedKeys.includes(input);
        });

        manageState([
            { key: "roleTemplates", value: filtered },
            { key: "searchInput", value: event.target.value }
        ]);
    } else {
        manageState([
            { key: "roleTemplates", value: roleTemplatesCopy },
            { key: "searchInput", value: event.target.value }
        ]);
    }
}

export default searchRoleTemplates